import { z } from 'zod/v4';

import { displayRestrictionTypeSchema } from './display-restriction-type.schema';

export const coPilotOptionsSchema = z.object({
  displayRestrictions: displayRestrictionTypeSchema,
});

export type CoPilotOptions = z.infer<typeof coPilotOptionsSchema>;
